import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import { Tooltip as MuiTooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const RequestStatus = ({ data }) => {
  const [requestData, setRequestData] = useState();

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/requests/requests');
  };

  useEffect(() => {
    // Always define all categories
    const categories = [
      { name: "Tenant", pending: 0, inProgress: 0, completed: 0, rejected: 0 },
      { name: "Staff", pending: 0, inProgress: 0, completed: 0, rejected: 0 },
      { name: "Manager", pending: 0, inProgress: 0, completed: 0, rejected: 0 },
      { name: "Owner", pending: 0, inProgress: 0, completed: 0, rejected: 0 },
    ];

    if (data && data.length > 0) {
      // Count requests for each type
      data.forEach((request) => {
        let category = null;
        if (request.requestedBy.type === "tenant") category = "Tenant";
        else if (request.requestedBy.type.startsWith("staff")) category = "Staff";
        else if (request.requestedBy.type === "manager") category = "Manager";
        else if (request.requestedBy.type === "owner") category = "Owner";

        if (category) {
          const cat = categories.find(c => c.name === category);
          if (request.status === "Pending") cat.pending++;
          if (request.status === "In-Progress") cat.inProgress++;
          if (request.status === "Completed") cat.completed++;
          if (request.status === "Rejected") cat.rejected++;
        }
      });
    }

    setRequestData(categories);
  }, [data]);

  const labelMap = {
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    rejected: "Rejected",
  };

  return (
    <div className="card">
      <div className="tooltip-header" style={{ display: "flex", alignItems: "center" }}>
        <MuiTooltip title="This shows the number of requests by status." arrow>
          <IconButton>
            <HelpOutlineIcon sx={{ fontSize: '18px', color: 'grey' }} />
          </IconButton>
        </MuiTooltip>
        <button className="redirect-btn" onClick={handleNavigate}>
          <i className="fa-solid fa-arrow-up-right-from-square"></i>
        </button>
      </div>

      <h2 className="card-title"><i className="fa fa-arrow-up-short-wide" />Requests by Status</h2>

      <div className="chart-container">
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={requestData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="category" dataKey="name" />
            <YAxis type="number" tick={false} width={20} />
            <Tooltip
              formatter={(value, name) => [value, labelMap[name] || name]}
            />
            <Legend
              iconType="circle"
              formatter={(value) => labelMap[value] || value}
            />
            <Bar stackId="a" dataKey="pending" fill="#C86B2C" barSize={70} />
            <Bar stackId="a" dataKey="inProgress" fill="#D4967D" barSize={70} />
            <Bar stackId="a" dataKey="completed" fill="#445485" barSize={70} />
            <Bar stackId="a" dataKey="rejected" fill="#818FB4" barSize={70} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RequestStatus;